var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"-79OHhC1A9tF88IBh-eh6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["new-company-web@pinkfong"]={id:"-79OHhC1A9tF88IBh-eh6"};
      